<template>
  <component :is="props.component" v-if="props.component" v-bind="props.attrs" />
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useCustomPageStore } from "@/store/customPage";

defineOptions({
  name: "custom-page",
});

const route = useRoute();
const customPageStore = useCustomPageStore();

const props = computed(() => {
  return customPageStore.getProps(route.path);
});
</script>
